import React from 'react';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import S from './Widget.module.scss';

const WidgetAlarmes = ({ alarmes = [] }) => {
  const latestAlarmes = alarmes.slice(0, 5);
  const hasAlarmes = latestAlarmes && latestAlarmes.length > 0;
  
  const getAlarmeSeverityClass = (severity) => {
    switch(severity) {
      case 1: return S.alarmeCritical;
      case 2: return S.alarmeWarning;
      default: return S.alarmeInfo;
    }
  };
  
  return (
    <div className={[S.widget, S.widgetMedium, S.widgetSimple].join(' ')}>
      <div className={S.simpleHeader}>
        <h3 className={S.simpleTitle}>{checkMot('mes_alarmes')}</h3>
      </div>
      <div className={S.simpleContent}>
        {hasAlarmes ? (
          <ul className={S.alarmeList}>
            {latestAlarmes.map((alarme, index) => (
              <li 
                key={alarme.alarm_id || index} 
                className={[S.alarmeItem, getAlarmeSeverityClass(alarme.alarm_level)].join(' ')}
              >
                <span className={S.alarmeDot}></span>
                <span className={S.alarmeText}>{alarme.message_alarm}</span>
                <span className={S.alarmeDate}>
                  {new Date(alarme.alarm_time_firing * 1000).toLocaleDateString()}
                </span>
              </li>
            ))}
          </ul>
        ) : (
          <div className={S.emptyStateSimple}>
            <span className={S.placeholder}>{checkMot('mes_alarmes')}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default WidgetAlarmes;
